import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile mr-s"
}, null, -1)

import CenteredCard from "@/components/CenteredCard.vue";

import { ref, onMounted } from "vue";
import { useAccountStore } from "@/store/accountStore";
import { useSessionStore } from "@/store/sessionStore";
import { useMedicationsStore } from "@/store/medicationsStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import LogoutLink from "@/modules/Settings/components/LogoutLink.vue";
import ResetPasswordFlowView from "./ResetPasswordFlowView.vue";
import LabelButton from "@/components/LabelButton.vue";
import VersionDisplay from "@/components/VersionDisplay.vue";
import { hexToBytes } from "@/helpers/encryption";
import LoadingCard from "@/components/LoadingCard.vue";
import { KeyPair } from "libsodium-wrappers";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPasswordView',
  setup(__props) {

const accountStore = useAccountStore();
const sessionStore = useSessionStore();
const medicationsStore = useMedicationsStore();

const password = ref<string>("");
const savePassword = ref<boolean>(false);
const isLoading = ref<boolean>(true);
const resetPassword = ref<boolean>(false);
const setProfile = async () => {
  sessionStore.password = password.value;
  accountStore.careProviderGroups = null;
  await init(undefined, savePassword.value);
};

const savedLogin = async () => {
  try {
    const saveKeyJson = sessionStorage.getItem("med_key");
    if (saveKeyJson && !sessionStore.keyPair) {
      const savedKey = JSON.parse(saveKeyJson);

      const keyPair = {
        keyType: savedKey.keyType,
        publicKey: hexToBytes(savedKey.publicKey),
        privateKey: hexToBytes(savedKey.privateKey),
      };

      await init(keyPair, undefined);
    }
  } finally {
    isLoading.value = false;
  }
};

const init = async (
  keyPair?: KeyPair | undefined,
  savePassword?: boolean | undefined
) => {
  await accountStore.loadProfile(keyPair, savePassword);
  await accountStore.loadCpgs();
  if (sessionStore.selectedCareProviderGroup?.is_shop) {
    await sessionStore.loadFtpSettings();
    medicationsStore.updateShopMedicationInformation();
  }
};

onMounted(() => {
  savedLogin();
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (isLoading.value)
    ? (_openBlock(), _createBlock(LoadingCard, { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode(" Laden... ")
        ]),
        _: 1
      }))
    : (resetPassword.value)
      ? (_openBlock(), _createBlock(ResetPasswordFlowView, { key: 1 }))
      : (_openBlock(), _createBlock(CenteredCard, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(UmanaHeadline, { h: "h1" }, {
                default: _withCtx(() => [
                  _createTextVNode("mediBe")
                ]),
                _: 1
              })
            ]),
            _createVNode(UmanaHeadline, { h: "h2" }, {
              default: _withCtx(() => [
                _createTextVNode("Willkommen zurück, " + _toDisplayString(_unref(accountStore).firstName ?? "") + " " + _toDisplayString(_unref(accountStore).lastName ?? ""), 1)
              ]),
              _: 1
            }),
            _createVNode(LogoutLink, { class: "mb-s text-start !justify-start" }),
            _createVNode(_component_FormKit, {
              type: "form",
              "submit-label": "Daten entschlüsseln",
              onSubmit: setProfile
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKit, {
                  type: "password",
                  name: "password",
                  label: "Passwort",
                  autofocus: "",
                  placeholder: "Passwort",
                  id: "password",
                  validation: "required",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                  help: "Bitte tippen Sie Ihr Passwort ein, damit Ihre Daten entschlüsselt werden können"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "checkbox",
                  modelValue: savePassword.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((savePassword).value = $event)),
                  label: "Passwort speichern",
                  help: "Dieses Feld darf nur bei privaten Geräten, auf welche niemand anderes Zugriff hat, angeklickt werden. Das Passwort wird gespeichert, bis der Browsertab geschlossen wird."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(LabelButton, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (resetPassword.value = true)),
              label: "Ich habe mein Passwort vergessen"
            }),
            _createVNode(VersionDisplay)
          ]),
          _: 1
        }))
}
}

})